// ---------------------------------------------------------------------------
// Site‑wide settings. Everything an editor might want to change lives here
// or in collections.js -- never inside a component.
// ---------------------------------------------------------------------------

const site = {
  name: "photoLevs",
  tagline: "Photography by Joseph Levermore",
  instagram: "https://www.instagram.com/photolevs",
  linkedin: "https://www.linkedin.com/in/joseph-michael-levermore",
  email: "levermorejoseph@gmail.com",

  // Storage folder holding the curated homepage set.
  featuredFolder: "Portfolio",

  // Shuffle the homepage grid/carousel (session‑stable).
  shuffleHome: true,

  // Portrait used on the About page (Storage path or full URL).
  aboutImage: "",

  about: [
    "Joseph Levermore, born in Birmingham, United Kingdom, was raised in a family passionate about art and its ability to express an individual's daily experiences. In realising the emotive power of photography, Joseph from a young age became captivated, and thus began his journey.",
    "In a world bursting with colour, Joseph wishes to challenge his audience by experiencing the world of duality: black and white. He sees black and white photography as a medium to inspire individuals to project their own stories onto images devoid of colour, but flushing in beauty.",
    "He is primarily interested in communicating the everyday experiences of city folk across the United Kingdom, and much of the work displayed here covers those experiences. His photography is not centralised on human‑based subjects but on the cityscape in the main.",
    "He hopes you enjoy his impressions. The stories captured through his lens are yours to tell\u2026",
  ],
};

export default site;